export default {
    "profile": "حساب تعريفي",
    "logout": "تسجيل خروج",
    "dashboard": "لوحة القيادة",
    "password": "كلمة المرور",
    "language": "لغة",
    "paymentbr": "قسط",
    "subscriptionPaymentMethod": "طريقة الاشتراك والدفع",
    "nothingchanged": "لا شيء تغير",
    "somethingWentWrong": "هناك خطأ ما ! يرجى المحاولة مرة أخرى في وقت لاحق",
    "pleaseTryAgainAfterSometime": "يرجى المحاولة مرة أخرى بعد وقت ما",
    "noChanges": "لم يتغير",
    "invalidEmailFormat": "تنسيق البريد الإلكتروني غير صالح",
    "chooseYourPreferredLanguage": "الرجاء اختيار لغتك المفضلة.",
    "selectLanguage": "اختار اللغة",
    "update": "تحديث",
    "languagePreferences": "تفضيلات اللغة",
    "packageOf": "حزمة من",
    "satelliteReport": "تقارير الأقمار الصناعية",
    "pastureReport": "تقارير المراعي",
    "upTo": "يصل إلى",
    "animals": "الحيوانات",
    "back": "خلف",
    "perMonth": "كل شهر",
    "perYear": "كل سنة",
    "continue": "يكمل",
    "changePlan": "خطة التغيير",
    "addOn": "اضافه",
    "totalPrice": "السعر الكلي",
    "availableAddOns": "الإضافات المتاحة",
    "next": "التالي",
    "congratulations": "تهانينا",
    "done": "منتهي",
    "deforestationComplianceAssessment": "تقييمات الامتثال لإزالة الغابات",
    "warning": "تحذير",
    "yourDataMightLost": "قد يتم فقدان البيانات الخاصة بك.",
    "clickOnSaveBtnMsg": "انقر على زر حفظ للحفاظ على البيانات الخاصة بك",
    "discardChanges": "تجاهل التغييرات",
    "action": "أجراءات",
    "sendRequest": "ارسل طلب",
    "success": "نجاح",
    "yourRequestSuccessfullySubmitted": "تم تقديم طلبك بنجاح.",
    "informShortly": "تم تقديم طلبك بنجاح. سيتم إرسال تقرير التحليل إليك قريبًا.",
    "search": "يبحث",
    "pending": "قيد الانتظار",
    "approved": "موافقة",
    "rejected": "مرفوض",
    "primaryGeofence": "السياج الجغرافي الأساسي",
    "Zero/Negligible Deforestation Probability": "احتمالية إزالة الغابات ضئيلة أو معدومة",
    "Low Deforestation Probability": "احتمالية إزالة الغابات منخفضة",
    "High Deforestation Probability": "احتمالية إزالة الغابات عالية",
    "login": {
        "welcome": "مرحباً! تسجيل الدخول",
        "welInfo": "أدخل بيانات الاعتماد الخاصة بك.",
        "login": "تسجيل الدخول",
        "emailMobile": "البريد الإلكتروني/الجوال",
        "forgotPassword": "هل نسيت كلمة السر",
        "register": "يسجل",
        "unableToLogin": "غير قادر على تسجيل الدخول",
        "emailMobileCannotEmpty": "لا يمكن أن يكون البريد الإلكتروني/الجوال فارغًا.",
        "invalidEmailMobileFormat": "تنسيق البريد الإلكتروني/الجوال غير صالح.",
        "passwordCannotEmpty": "لا يمكن أن تكون كلمة المرور فارغة.",
        "passwordLengthCanlessthan8": "لا يمكن أن يقل طول كلمة المرور عن 8 أحرف.",
        "email": "بريد إلكتروني",
        "phone": "هاتف",
        "or": "أو",
        "alreadyHaveAccount": "هل لديك حساب",
        "loginNow": "تسجيل الدخول الآن",
        "registerOption": "اختر خيارًا للتسجيل",
        "signUpWith": "سجل مع"
    },
    "user": {
        "profileUpdated": "تم تحديث الملف الشخصي بنجاح",
        "profileNotUpdated": "لم يتم تحديث الملف الشخصي",
        "otpSentOnEmail": "تم إرسال كلمة المرور لمرة واحدة بنجاح!",
        "otpSentSuccessFully": "تم إرسال رمز OTP الخاص بك",
        "unableToVerifyEmail": "غير قادر على التحقق من البريد الإلكتروني",
        "emailCanNotBeEmpty": "لا يمكن أن تكون حقول البريد الإلكتروني فارغة",
        "firstName": "الاسم الأول",
        "lastName": "اسم العائلة",
        "email": "بريد إلكتروني",
        "mobile": "متحرك",
        "currentPassword": "كلمة السر الحالية",
        "newPassword": "كلمة المرور الجديدة",
        "repeatNewPassword": "كرر كلمة المرور الجديدة",
        "firstNameRequired": "الإسم الأول مطلوب.",
        "lastNameRequired": "إسم العائلة مطلوب",
        "emailRequired": "البريد الالكتروني مطلوب",
        "onlyAlphabet": "يمكن أن تحتوي على الحروف الهجائية فقط",
        "notMoreThan15Char": "لا يمكن أن يكون أكثر من 15 حرفًا",
        "phoneCannotLessThan8Char": "لا يمكن أن يقل حجم الهاتف عن 8 أحرف",
        "countryCodeRequire": "مطلوب رمز البلد",
        "changePassword": "تغيير كلمة المرور",
        "goodIdeaToUsePassword": "إنها فكرة جيدة أن تستخدم كلمة مرور قوية لا تستخدمها في أي مكان آخر.",
        "enterCurrentPassword": "إدخل كلمة السر الحالية",
        "enterNewPassword": "أدخل كلمة المرور الجديدة",
        "reEnterPassword": "إعادة إدخال كلمة المرور",
        "pleaseTypeOldPassword": "الرجاء كتابة كلمة المرور القديمة.",
        "pleaseTypeNewPassword": "الرجاء كتابة كلمة المرور الجديدة.",
        "pleaseTypeConfirmPassword": "الرجاء كتابة تأكيد كلمة المرور.",
        "passwordChangedSuccesFully": "تم تغيير الرقم السري بنجاح",
        "passwordDoesNotMatch": "كلمات المرور غير متطابقة.",
        "passwordRequired": "كلمة المرور مطلوبة",
        "emailOrPhoneIsRequired": "مطلوب البريد الإلكتروني أو رقم الهاتف"
    },
    "subscription": {
        "subscription": "الاشتراك",
        "membershipPlan": "خطط العضوية",
        "currentMembershipPlan": "خطة العضوية الحالية",
        "validUpTo": "صالحة حتى",
        "viewAllAddOns": "عرض جميع الإضافات",
        "renewValidity": "تجديد الصلاحية",
        "buyNow": "اشتري الآن",
        "upgradeMembershipPlan": "ترقية خطة العضوية",
        "chooseYourMembershipPlan": "خطة العضوية التي اخترتها",
        "chooseOptionalAddOns": "يمكنك اختيار الوظائف الإضافية الاختيارية",
        "yourSelectedAddons": "الإضافات التي اخترتها",
        "addAnotherAddOn": "إضافة وظيفة إضافية أخرى",
        "paymentMethod": "طريقة الدفع او السداد",
        "addingAPaymentMethod": "إضافة طريقة الدفع",
        "paymentSuccessful": "تم الدفع بنجاح!",
        "weHaveEmailed": "لقد أرسلنا نسخة من إيصالك عبر البريد الإلكتروني إلى example@email.com",
        "paymentAuthorizedSuccessfully": "تمت الموافقة على الدفع بنجاح.",
        "paymentSuccessfulPrompt": "تم الدفع بنجاح. تمت ترقية الخطة.",
        "paymentCancelled": "تم إلغاء الدفع. حاول مرة اخرى."
    },
    "registerFarm": "سجل المزرعة",
    "requestDeforestationReport": "طلب تقرير إزالة الغابات",
    "paymentMenu": "قسط",
    "complianceCertificate": "شهادة الامتثال",
    "helpDisk": "قرص المساعدة",
    "faqs": "الأسئلة الشائعة",
    "enquiries": "استفسارات",
    "contactUs": "اتصل بنا",
    "payment": {
        "basicPlan": "الخطة الأساسية",
        "advancePlan": "الخطة المسبقة",
        "usdPerMonthPlus": "دولار أمريكي شهريًا بالإضافة إلى",
        "perReport": "لكل تقرير",
        "deforestationAnalyticsCertificateDownload": "تحميل شهادة تحليل إزالة الغابات"
    },
    "farm": {
        "farmOwnershipType": "نوع ملكية المزرعة",
        "licenceNum": "رقم الرخصة",
        "viewFarm": "عرض المزرعة",
        "stateProvince": "المقاطعة/الولاية",
        "postalNumberShouldSimilarToFarm": "الرقم البريدي للمزرعة مشابه لرقم المنزل.",
        "videoTutorial": "فيديو تعليمي",
        "clickOnMapMSG": "انقر على الخريطة لبدء تحديد الموقع الجغرافي",
        "prev": "السابق",
        "next": "التالي",
        "dragVertexMsg": "يمكنك أيضًا سحب القمم أو حذفها باستخدام زر الحذف الموجود على الجانب الأيمن. يمكن أيضًا مسح السياج الجغرافي باستخدام زر المسح",
        "farmAddedSuccessfully": "تمت إضافة المزرعة بنجاح",
        "perimeter": "محيط",
        "area": "منطقة",
        "clearGeofence": "مسح السياج الجغرافي",
        "deleteSelectedVertex": "حذف قمة الرأس المحددة",
        "pleaseStartDrawing": "يرجى البدء في رسم السياج الجغرافي على الخريطة.",
        "chooseTheDate": "اختر التاريخ",
        "updateGeofenceForThisFarm": "تحديث GEOFENCE لهذه المزرعة",
        "farmUpdateSuccessfully": "تم تحديث المزرعة بنجاح",
        "farmZone": "مناطق المزرعة",
        "addNewZones": "إضافة مناطق جديدة",
        "zoneName": "اسم المنطقة",
        "addZoneToCreate": "الرجاء الضغط على \"إضافة مناطق\" لإنشاء منطقة لهذه المزرعة.",
        "noZoneCreated": "لم يتم إنشاء أي مناطق حتى الآن.",
        "searchAndAddPin": "بحث وإضافة دبوس",
        "zoneNameWillBeHere": "اسم المنطقة سيكون هنا",
        "editZone": "تحرير المنطقة",
        "nameOfTheField": "اسم المجال",
        "zoneDetails": "تفاصيل المنطقة",
        "addZone": "أضف منطقة",
        "nameOfTheZone": "اسم المنطقة",
        "geofenceIsRequiredToAdd": "مطلوب Geofence لإضافة منطقة. انقر فوق \"تحرير المزرعة\" لإضافة تفاصيل السياج الجغرافي إلى مزرعتك.",
        "thisFieldApplyHelpText": "ينطبق هذا المجال عليك فقط إذا كنت تنتمي إلى أي تعاونية (التعاونية هي رابطة مستقلة لأشخاص متحدين طوعًا لتلبية احتياجاتهم وتطلعاتهم الاقتصادية والاجتماعية والثقافية المشتركة من خلال مؤسسة ذات ملكية مشتركة وتدار بشكل ديمقراطي). إذا كنت تنتمي إلى جمعية تعاونية، فيرجى الإشارة إلى المعرف الفريد لتلك التعاونية، ويمكن أن يكون رقم تسجيل أو رقم ترخيص يحدد بشكل فريد التعاونية التي ترتبط بها.",
        "farmRegistrationID": "معرف تسجيل المزرعة",
        "farmerName": "اسم المزارع",
        "farmerRegistrationID": "معرف تسجيل المزارع",
        "dateOfRequest": "تاريخ الطلب",
        "status": "حالة",
        "address": "عنوان",
        "save": "يحفظ",
        "farmAddress": "عنوان موقع المزرعة",
        "corporateName": "اسم الشركة",
        "corporateMailingAddress": "العنوان البريدي للشركات",
        "farmID": "معرف المزرعة",
        "onTheFarm": "في المزرعة",
        "userRoles": "أدوار المستخدمين",
        "adduser": "إضافة مستخدم",
        "addAuser": "إضافة مستخدم",
        "uploadUsers": "تحميل المستخدمين",
        "addNewUser": "إضافة مستخدم جديد",
        "selectDept": "اختر القسم",
        "selectRole": "حدد الدور",
        "editUser": "تحرير العضو",
        "totalFarms": "إجمالي المزارع",
        "NoAnimalsRegisteredForthisFarm": "لم يتم تسجيل أي حيوانات لهذه المزرعة",
        "farmsPerPage": "المزارع لكل صفحة",
        "regularFarms": "المزارع العادية",
        "farmRegisteredProducts": "المنتجات الزراعية المسجلة",
        "searchByFarmNameAndId": "البحث حسب اسم المزرعة والمعرف",
        "loadingProductsPleaseWait": "جارٍ تحميل المنتجات... الرجاء الانتظار",
        "farmName": "اسم المزرعة",
        "farmLocation": "موقع المزرعة",
        "productName": "اسم المنتج",
        "stockStatus": "حالة الرصيد، وضع مخزون",
        "inStock": "في الأوراق المالية",
        "searchByProductName": "البحث حسب اسم المنتج",
        "productCategory": "فئة المنتج",
        "products": "منتجات",
        "yourLocationIsDisabled": "تم تعطيل موقعك. يرجى البحث عن موقعك من القوائم اليسرى.",
        "close": "يغلق",
        "farms": "مزارع",
        "zones": "المناطق",
        "registerAfarm": "تسجيل مزرعة",
        "govtRegistry": "الحكومة. التسجيل",
        "cooperativeID": "معرف التعاونية/الاتحاد",
        "cooperativeName": "اسم التعاونية/الاتحاد",
        "farmType": "نوع المزرعة",
        "contractMating": "تزاوج العقد",
        "customization": "التخصيص",
        "recordsPerpage": "تسجيلات لكل صفحة",
        "restoreDefault": "استعادة الافتراضي",
        "apply": "يتقدم",
        "CommunityName": "اسم المجتمع",
        "searchState": "البحث حسب معرف المزرعة، السجل الحكومي، معرف التعاونية، نوع المزرعة، عقد التزاوج",
        "farmOwner": "مالك المزرعة",
        "govRegistrationNo": "رقم التسجيل الحكومي",
        "farmInformation": "معلومات المزرعة",
        "ownershipType": "نوع الملكية",
        "farmLicenseInformation": "معلومات ترخيص المزرعة",
        "licenseNumber": "رقم الرخصة",
        "licenseExpiryDate": "تاريخ انتهاء الترخيص",
        "regulatorName": "اسم المنظم",
        "regulatorRepresentativeName": "اسم ممثل الجهة التنظيمية",
        "farmLocationSize": "موقع المزرعة وحجمها",
        "productionSystem": "نظام الزراعة",
        "country": "دولة",
        "state": "ولاية",
        "city": "القرية/البلدة/المدينة",
        "farmNumber": "رقم المزرعة",
        "postal": "الرمز البريدي/الرمز البريدي",
        "houseNumber": "رقم الدار",
        "farmRegistration": "تسجيل المزرعة",
        "cancel": "يلغي",
        "register": "يسجل",
        "ok": "نعم",
        "totalFarmSize": "إجمالي حجم المزرعة",
        "geographicLocation": "الموقع الجغرافي",
        "farmGeographicLocation": "الموقع الجغرافي للمزرعة",
        "perimeterPointLongitude": "محيط نقطة الطول",
        "perimeterPointLatitude": "محيط نقطة العرض",
        "perimeterPointLabel": "تسمية النقطة المحيطة",
        "perimeterLength": "طول المحيط",
        "farmLatitude": "خط عرض المزرعة",
        "farmLongitude": "خط طول المزرعة",
        "latitude": "خط العرض",
        "longitude": "خط الطول",
        "areaUnit": "وحدة المساحة",
        "walkAndMeasure": "المشي والقياس",
        "useGeofenceTool": "استخدم أداة السياج الجغرافي",
        "editFarm": "تحرير المزرعة",
        "update": "تحديث",
        "editAfarm": "تحرير مزرعة",
        "nextFarm": "المزرعة التالية",
        "nameoftheFarm": "اسم المزرعة",
        "registerAProduct": " تسجيل منتج",
        "farmProducts": "منتجات مزارع",
        "calf": "عجل",
        "steer": "توجيه",
        "heifer": "عجلة",
        "sire": "مولى",
        "dam": "سد",
        "registerAnAnimal": "تسجيل حيوان",
        "farmAnimals": "حيوانات المزرعة",
        "farm_type": "نوع المزرعة",
        "farm_Owner": "مالك المزرعة",
        "dateOfRegistration": "تاريخ التسجيل",
        "dataIsNotAvailableForThisFarm": "البيانات غير متوفرة لهذه المزرعة",
        "registerNewProduct": "تسجيل منتج جديد",
        "information": "معلومة",
        "licenseInfo": "معلومات الترخيص",
        "locationInfo": "معلومات الموقع",
        "geoLocation": "الموقع الجغرافي",
        "perimeterLengthState": "طول محيط المزارع (طول السياج)",
        "totalFarmSizeState": "حجم المزرعة",
        "productionSystemState": "نظام الإنتاج المستخدم في المزرعة",
        "contractMatingState": "مدونة برنامج التزاوج التعاقدي الذي تشارك فيه المزرعة.",
        "ownershipTypeState": "نوع الملكية",
        "regulatorRepresentativeNameState": "اسم الشخص الذي يمثل الجهة التنظيمية والذي أصدر الترخيص",
        "regulatorNameState": "اسم الجهة التنظيمية التي أصدرت الترخيص",
        "licenseExpiryDateState": "التاريخ الذي تنتهي فيه صلاحية الترخيص الحالي",
        "licenseNumberState": "رقم الترخيص الصادر عن المنظم",
        "plotNumberState": "رقم منزل المزرعة.",
        "plotNumber": "رقم المزرعة",
        "streetStatement": "اسم شارع المزرعة",
        "cityStatement": "المدينة التي تقع فيها المزرعة.",
        "stateStatement": "منطقة البلد التي تقع فيها المزرعة.",
        "countryState": "البلد الذي تقع فيه المزرعة.",
        "farmStateInfo": "عنوان مكان المزرعة",
        "perimeterPointLongitudeState": "خط طول نقطة واحدة في المزرعة.",
        "perimeterPointLatitudeState": "خط عرض نقطة واحدة على المزرعة.",
        "perimeterPointLabelState": "تسمية النقطة.",
        "farmLongitudeState": "خط طول المزرعة.",
        "farmLatitudeState": "خط عرض المزرعة.",
        "deleteFarm": "حذف المزرعة",
        "corporateRegistrationNum": "رقم تسجيل الشركة",
        "farmLocationIsRequired": "مطلوب موقع المزرعة."
    },
    "deforestation": {
        "addZoneToThisFarm": "أضف مناطق إلى هذه المزرعة",
        "eudrForestAssessment": "تقييمات الغابات EUDR",
        "requestEudrForestAssessment": "طلب تقييم الغابات من الاتحاد الأوروبي",
        "pleaseChooseOption": "الرجاء اختيار الخيار",
        "requestForestReport": "طلب تقرير الغابات",
        "noDeforestationReportMsg": "ولم يتم طلب أي تقارير عن إزالة الغابات. يرجى طلب بعض تقارير إزالة الغابات لإدراجها هنا.",
        "allCountries": "كل البلدان",
        "allRegions": "كل المناطق",
        "allFarms": "جميع المزارع",
        "allStatus": "كل الحالة",
        "viewCertificate": "عرض الشهادة",
        "requestComplianceCertificate": "طلب شهادة الامتثال",
        "assessmentNo": "رقم التقييم",
        "blockchainCertificationInfo": "ستكون تجزئة التحقق من صحة شهادة Blockchain متاحة عند قبول الشهادة",
        "blockchainCertificationValidation": "التحقق من صحة شهادة Blockchain",
        "openBlockchainPage": "افتح صفحة بلوكتشين",
        "clickOnAboveLink": "انقر على الرابط أعلاه للتحقق من صحة الشهادة على blockchain",
        "shareCertificate": "شهادة الأسهم",
        "high": "عالي",
        "low": "قليل",
        "zeroOrNegigible": "صفر أو لا يذكر",
        "deforestationProbability": "احتمال إزالة الغابات",
        "colorCode": "رمز اللون",
        "geofenceAarea": "منطقة السياج الجغرافي",
        "percentageOfGeofenceArea": "النسبة المئوية لمنطقة السياج الجغرافي",
        "overallDeforestationProbability": "احتمالية إزالة الغابات بشكل عام",
        "deforestationComplianceReport": "تقارير الامتثال لإزالة الغابات",
        "noDeforestationComplianceReport": "لم يتم العثور على تقرير إلكتروني حول الامتثال لإزالة الغابات",
        "loadingDeforestationComplianceReport": "تحميل التقرير الإلكتروني للامتثال لإزالة الغابات",
        "farmRegistrationId": "معرف تسجيل المزرعة",
        "farmerName": "اسم المزارع",
        "farmerRegistrationId": "معرف تسجيل المزارع",
        "uniqueFarmerId": "معرف المزارع الفريد",
        "uniqueFarmId": "معرف المزرعة الفريد",
        "farmLocation": "موقع المزرعة",
        "area": "منطقة",
        "farmAddress": "عنوان المزرعة",
        "dateOfRequest": "تاريخ الطلب",
        "status": "حالة",
        "settings": "إعدادات",
        "assignmentIssued": "تم إصدار المهمة",
        "certificateIssued": "شهادة صادرة",
        "complianceCertification": "شهادة الامتثال",
        "noComplianceCertification": "لم يتم العثور على شهادة الامتثال",
        "loadingComplianceCertification": "جارٍ تحميل شهادة الامتثال",
        "assessmentReport": "تقرير التقييم",
        "downloadPDF": "تحميل PDF",
        "print": "مطبعة",
        "back": "خلف",
        "farmDetails": "تفاصيل المزرعة",
        "dimitraFarmId": "معرف مزرعة ديميترا",
        "dimitraFermerId": "معرف مزارع ديميترا",
        "totalGeofenceAreaHA": "إجمالي منطقة السياج الجغرافي (HA)",
        "forestLossHA": "فقدان الغابات (HA)",
        "forestGainHA": "مكاسب الغابات (HA)",
        "forestUnchangedHA": "الغابة دون تغيير (HA)",
        "forestUnchanged": "الغابة لم تتغير",
        "forestLoss": "خسارة الغابات",
        "forestGain": "مكاسب الغابات",
        "totalGeofenceArea": "إجمالي منطقة السياج الجغرافي",
        "forestAssessmentHelp": "إذا كانت لديك أسئلة حول هذا التقرير أو كنت بحاجة إلى مساعدة في فهمه، فاتصل بنا من خلال مكتب المساعدة.",
        "allReport": "جميع التقارير",
        "deforestationRepot": "تقارير إزالة الغابات",
        "requestDeforestationReportNow": "اطلب تقرير إزالة الغابات الآن",
        "noRecordFound": "لا يوجد سجلات",
        "noDeforestationReportRequested": "ولم يتم طلب أي تقارير عن إزالة الغابات. يرجى طلب بعض تقارير إزالة الغابات لإدراجها هنا.",
        "deforestationImage": "صورة إزالة الغابات",
        "reqDeforestationReport": "طلب تقرير إزالة الغابات",
        "confirm": "يتأكد",
        "newForestArea": "منطقة الغابات الجديدة",
        "deforestedArea": "المنطقة التي أزيلت منها الغابات",
        "existingForestArea": "منطقة الغابات القائمة",
        "deforestation": "إزالة الغابات",
        "farmName": "اسم المزرعة",
        "location": "موقع",
        "dateOfInterest": "تاريخ الاهتمام",
        "geofenceArea": "منطقة السياج الجغرافي (HA)",
        "deforestationArea": "منطقة إزالة الغابات (HA)",
        "treeGainArea": "منطقة كسب الشجرة (HA)",
        "currentForestArea": "منطقة الغابات الحالية (HA)",
        "view": "منظر",
        "locationInfoRequired": "معلومات الموقع مطلوبة",
        "geofenceNameRequired": "اسم السياج الجغرافي مطلوب",
        "futureDateSelected": "تم تحديد التاريخ المستقبلي",
        "reportGeneratedSuccessfully": "تم إنشاء التقرير بنجاح",
        "reportCannotAdded": "لا يمكن إضافة التقرير.",
        "primaryFarmNotFound": "لم يتم العثور على المزرعة الأساسية.",
        "pleaseRegisterFarmFirst": "يرجى تسجيل المزرعة أولا",
        "tooltip": {
            "dimitraFarmId": "المعرف الفريد المرتبط بمزرعة معينة في نظام ديميترا.",
            "farmName": "الاسم المعين للمزرعة.",
            "farmRegistrationId": "رقم التسجيل للمزرعة.",
            "farmLocation": "الإحداثيات الجغرافية المحددة أو موقع المزرعة.",
            "dimitraFarmerId": "معرف مميز مرتبط بمزارع فردية داخل نظام ديميترا.",
            "farmerName": "تحديد الفرد المسؤول عن المزرعة.",
            "farmerRegistrationId": "رقم تسجيل المزارع.",
            "assessmentNo": "رقم فريد مخصص للتقييم."
          }
    },
    "certificate": {
        "allCertificate": "جميع الشهادات",
        "certificate": "شهادة"
    }
}